import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('management-reports-personalizations', storeModule.createStoreModule('management-reports-personalizations'))
